import React from 'react';
import './HlFundUsdcPanel.css';

/** Header / toolbar button — opens {@link HlFundUsdcModal}. */
export default function HlFundUsdcButton({ onClick, className = 'hl-fund-header-btn', children = 'Fund HL' }) {
  return (
    <button type="button" className={className} onClick={onClick}>
      {children}
    </button>
  );
}
